<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{path:'/home'}">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{path:'/callOldTotal'}">{{$t('zclstj')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('cd2')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('dc12')">
                                    <el-input v-model="searchform.employeeName" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div v-loading="loading">
                        <el-table :data="list"
                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                            <el-table-column prop="accountBook" :label="$t('paymentDays')"></el-table-column>
                            <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                            <el-table-column prop="employeeName" :label="$t('dc12')"></el-table-column>
                            <el-table-column :formatter="formatInteres" prop="orderToMoney" :label="$t('dc23')"></el-table-column>
                            <el-table-column :formatter="formatInteres" prop="orderPayMoney" :label="$t('dc24')"></el-table-column>
                            <el-table-column prop="orderToMoneyRate" :label="$t('dc25')"></el-table-column>
                            <el-table-column prop="orderToday" :label="$t('dc22')"></el-table-column>
                            <el-table-column prop="completeDay" :label="$t('dc14')"></el-table-column>
                            <el-table-column prop="dayNewRate" :label="$t('dc15')"></el-table-column>
                            <el-table-column prop="remainderRepaid" :label="$t('dc16')"></el-table-column>

                            <el-table-column prop="extensionNumber" :label="$t('re17')"></el-table-column>
                            <el-table-column prop="extensionRate" :label="$t('re18')"></el-table-column>

                            <el-table-column prop="coverageRate" :label="$t('re19')"></el-table-column>
                            <el-table-column prop="numberTotal" :label="$t('re20')"></el-table-column>
                            <el-table-column prop="callCompletingRate" :label="$t('re21')"></el-table-column>
                            <el-table-column prop="callDuration" :label="$t('re22')"></el-table-column>
                        </el-table>
                        <div class="page">
                            <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                                @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            return {
                searchform: {
                    blurry: "",
                },
                loading: false,
                list: [],
                total: 1,
                pageNo: 1,
                pageSize: 10,
            }
        },
        created() {
            this.user = JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            formatInteres(row, column, value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            getList() {
                this.loading = true
                _api.get(apiurl.calldateil, {
                    page: this.pageNo,
                    size: this.pageSize,
                    employeeName: this.searchform.employeeName,
                    groupId: this.$route.query.groupId,
                    nation:localStorage.getItem("nation"),
                    time: this.$route.query.time
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                    this.total = res.data.totalCount
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }
    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
    .toptj{ 
        display: flex; 
        margin: 5px 0;
        border: #ebedf0 solid 2px; 
        background: #ffffff; 
        height: 136px; 
    }
</style>